import { InputTag } from 'mixs/base/input_mixin';
export class CheckboxPhase extends InputTag {
  public init() {
    super.init();
    this.watch();
  }
  public onChange(e){
    let scope = "phase_" + e.target.value
    let newValue = {};
    newValue[scope] = e.target.checked;
    this.dispatchNewValue({
      forms_orders_save: newValue
    })
  }
}

riot.mixin('inputs.complex.checkbox-phase', CheckboxPhase as riot.TagMixin)
